// @flow
import * as React from 'react'
import { type ComponentType } from 'react'
import styled from 'styled-components'

type Props = {
  /** Flexbox content */
  children?: React.Node,
  /** Flex grow factor */
  flex?: number,
  /** Align content to center */
  selfCenter?: boolean,
  className?: string,
}

const StyledFlex: ComponentType<Props> = styled.div`
  flex: ${({ flex }: Props) => flex};
  ${({ selfCenter }: Props) => selfCenter && 'align-self: center;'}
`

/** Flexible boxes to be used inside Flex */
const FlexBox = ({ flex, children, ...props }: Props): React.Node => (
  <StyledFlex {...props} flex={flex || 1}>
    {children}
  </StyledFlex>
)
export default FlexBox
